import { render } from "./AreaIcon.vue?vue&type=template&id=39a1a982"
import script from "./AreaIcon.vue?vue&type=script&lang=js"
export * from "./AreaIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__